import Page from './ShiftCompareBlock.js';
import { connect } from 'react-redux';

const mapStateToProps = state => {
    const { factorSummaryV2 } = state;
    const { timeRange } = factorSummaryV2;
    return {
        timeRange,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
    };
};

const WrapperedPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Page);

export default WrapperedPage;